module.exports = "build/assets/mobileLeftSmallPapers.656efadf.png";